import React, { useEffect, useRef, useState } from "react";
import "./CourseInside.css";
import CourseDetails from "./layout/CourseDetails";
import Playlist from "./layout/Playlist";
import Footer from "../Footer/Footer";
import { Link, useParams } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
// import { FacebookShareButton, TwitterShareButton } from "react-share";



const CourseInside = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [UNP, setUNP] = useState(false);
  const [logFirst, setLogFirst] = useState(false);
  const { _id } = useParams();

  // to copy the url and pass to facebook icon
  // const url = window.location.href;

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/course/${_id}`, {
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        // console.log("25", data);
        if (data.status === "success") {
          setLoading(false);
          setCourses(data.msg);
          setUNP(false);
        } else if (data.msg === "Login first") {
          setLogFirst(true);
          setLoading(false);
        } else {
          setLoading(false);
          setUNP(true);

          // console.clear();
        }
        // setCourses(data.msg);
        // console.log("data",data)
      });
  }, [_id]);

 

  if (loading) {
    return (
      <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
        <div className="lds-dual-ring"></div>
      </div>
    );
  } else if (logFirst) {
    return (
      <div className="not-Premium">
        <div className="container mt-5">
          <div className="row">
            <div className="col-md-11 m-auto">
              <h3 className="text-center text-not-Premium">
                Sorry, Please Login First.
              </h3>
              <div className="text-center mt-4">
                <Link to="/login" className="btn btn-premium">
                  Go to Login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (UNP) {
    return (
      <div className="not-Premium">
        <div className="container mt-5">
          <div className="row">
            <div className="col-md-11 m-auto">
              <h3 className="text-center text-not-Premium">
                Sorry, you are not premium user. Please upgrade your account to.
              </h3>
              <div className="text-center mt-4">
                <Link to="/pricing" className="btn btn-premium">
                  Go to Pricing
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      <Helmet>
        <title>Text Genuss | {courses.name}</title>
        <link
          rel="icon"
          href="https://res.cloudinary.com/dia1kfg4m/image/upload/v1655037405/LogoWithNoText_kptpy3.svg"
        />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
        <meta name="theme-color" content="#ffffff" />
        <meta property="title" content={courses.name} />
        <link rel="canonical" href={`/course-inside/${courses.id}`} />
        {/* <meta property="quote" content={tvInsider.about} /> */}
        {/* <meta name="description" content={tvInsider.about} /> */}
        <meta property="image" content={courses.photo} />
        <meta property="og:description" content="from course test" />
        <meta name="description" content="description test" />
        <meta property="og:locale" content="ar_KSA" />
        <meta property="og:type" content="website" />
        {/* that is the most important meta */}
        <meta property="og:title" content={courses.name} />
        {/* ======== new meta ======== */}
        <meta
          property="og:image"
          data-rh="true"
          content="https://res.cloudinary.com/dia1kfg4m/image/upload/w_200,h_200,c_thumb,g_faces/v1655633299/download_1_rjg5xy.jpg"
        />
        {/* <meta property="og:image" content="https://res.cloudinary.com/dia1kfg4m/image/upload/w_200,h_200,c_thumb,g_faces/v1655560271/download_o26ipp.jpg" /> */}
        <meta
          property="og:image:secure_url"
          data-rh="true"
          content="https://res.cloudinary.com/dia1kfg4m/image/upload/w_200,h_200,c_thumb,g_faces/v1655560271/download_o26ipp.jpg"
        />
        <meta property="og:image:width" content="200" />
        <meta property="og:image:height" content="200" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:image"
          data-rh="true"
          content="https://res.cloudinary.com/fay/image/upload/w_1280,h_640,c_fill,q_auto,f_auto/w_860,c_fit,co_rgb:232129,g_west,x_80,y_-60,l_text:Source%20Sans%20Pro_70_line_spacing_-10_semibold:Anyone%20Can%20Map!%20Inspiration%20and%20an%20introduction%20to%20the%20world%20of%20mapping/blog-social-card-1.1"
        />
        <meta property="twitter:site" content="Text Genuss in twitter" />
        {/* <meta property="og:image" content={courses.photo} />
          <meta property="og:image:secure" content={courses.photo}/> */}
        {/* <meta property="og:image" content="https://res.cloudinary.com/dia1kfg4m/image/upload/w_200,h_200,c_thumb,g_faces/v1655560271/download_o26ipp.jpg" /> */}
        <meta
          property="og:image:secure"
          content="https://res.cloudinary.com/dia1kfg4m/image/upload/w_200,h_200,c_thumb,g_faces/v1655560271/download_o26ipp.jpg"
        />
        <meta property="og:url" content="https://textgenuss.net" />
        <meta content="image/*" property="og:image:type" />
        <meta property="og:site_name" content="Text Genuss" />
      </Helmet>

      <div className="CourseInside">
        <div className="container">
          <div>
            <Playlist courses={courses} />
          </div>
          <div>
            <CourseDetails courses={courses} id={_id} />
          </div>
          <div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default CourseInside;
